import { render, staticRenderFns } from "./PreResult.vue?vue&type=template&id=d615fc68&scoped=true&"
import script from "./PreResult.vue?vue&type=script&lang=js&"
export * from "./PreResult.vue?vue&type=script&lang=js&"
import style0 from "./PreResult.vue?vue&type=style&index=0&id=d615fc68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d615fc68",
  null
  
)

export default component.exports